import { Flex, Rating, Stack, Text } from "@mantine/core";

import { FeedbackData } from "@/builders/types/admin-dashboard";

import dayjs from "dayjs";
import locale from "dayjs/plugin/localizedFormat";
dayjs.extend(locale);

interface UserFeedbackListProps extends FeedbackData {}

export function UserFeedbackCard({
  first_name,
  last_name,
  rating,
  feedback,
  feedback_created_at,
}: UserFeedbackListProps) {
  return (
    <Stack
      className="border rounded-lg border-primary-border-light bg-primary-background-subtle text-primary-text-body"
      p={8}
      gap={12}
      flex={1}
    >
      <Stack gap={2}>
        <Text
          fz={16}
          fw={500}
          className="border-b text-primary-text-body border-primary-border-light"
        >
          {first_name} {last_name}
        </Text>
        <time className="prose-sm/regular text-primary-text-subtle">
          {dayjs(feedback_created_at).format("LLL")}
        </time>
      </Stack>

      <Stack
        gap={4}
        className="border rounded-md border-accent-6"
        bg="accent.3"
        p="sm"
      >
        <Text>
          <Text span className="prose-sm/medium text-primary-text-body">
            Feedback:
          </Text>{" "}
          <Text span className="text-primary-text-subtle">
            {feedback}
          </Text>
        </Text>

        <Flex gap={8} align="center">
          <Text className="prose-sm/medium ttext-primary-text-body">
            <Text span className="prose-sm/medium text-primary-text-body">
              Rating:
            </Text>{" "}
            <Text span className="text-primary-text-subtle">
              {rating}
            </Text>
          </Text>

          <Flex justify="space-between">
            <Rating readOnly value={rating} />
          </Flex>
        </Flex>
      </Stack>
    </Stack>
  );
}
